











import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "ConfirmSensitiveContentView",
  components: { BaseConfirm, BaseButton },
  props: {
    hide: { type: Boolean, required: true },
  },
});
